/* eslint-disable react-hooks/exhaustive-deps */
import { useGlobalStore } from "@/store/GlobalStore";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  FoxGiftCouponCard,
  FoxGiftCouponCardList,
  FoxGiftCouponWrapper,
  CardListContent,
} from "./atom";
import { couponTypeTranslate } from "@/components/top-up/help/couponTypeTranslate";
import { useEffect, useState } from "react";
import CheckIcon from "@/assets/icons/topup/check";
import CouponIcon from "@/assets/icons/topup/coupon-icon";
import LeftIcon from "@/assets/icons/topup/left-icon";
import RightIcon from "@/assets/icons/topup/right-icon";
import { useFoxTopUpStore } from "../../store";
import { presentAmountCalculate } from "@/components/top-up/help/activityUtil";
import { useScrollCard } from "./hooks/useScrollCard";
import { BindActivityInfo } from "@/components/top-up/types";
import { CommonCornerMark } from "../../atom";

export function FoxGiftCoupon({
  activityInfo,
}: {
  activityInfo: BindActivityInfo;
}) {
  const { t } = useTranslation("topup");
  const { currencySymbol } = useGlobalStore();
  const [checkCard, setCheckCard] = useState(activityInfo.activityDetail[0]);
  const [searchParams] = useSearchParams();
  const card = searchParams.get("chooseCard");
  const isCheckCard = useFoxTopUpStore((state) => state.isCheckCard);
  const activeName = useFoxTopUpStore((state) => state.activeName);
  const { setter: setFoxTopUpStore } = useFoxTopUpStore();
  const { isLeftHidden, isRightHidden, scrollRight, scrollLeft, wrapperRef } =
    useScrollCard();

  useEffect(() => {
    if (card) {
      setCheckCard(
        activityInfo.activityDetail.find(
          (item) => item.amount === Number(card)
        ) || {}
      );
      setFoxTopUpStore({
        amount: Number(card),
        isCheckCard: true,
      });
    } else {
      setCheckCard(activityInfo.activityDetail[0]);
      setFoxTopUpStore({
        amount: activityInfo.activityDetail[0].amount,
        isCheckCard: true,
      });
    }
  }, [activeName]);

  return (
    <FoxGiftCouponWrapper>
      <CardListContent>
        {activityInfo.activityDetail.length > 4 && !isLeftHidden && (
          <LeftIcon
            onClick={scrollLeft}
            className="scroll-button left-button"
          />
        )}
        <div className="card-list-wrapper" ref={wrapperRef}>
          <FoxGiftCouponCardList className="cards-wrapper">
            {activityInfo.activityDetail.map((item) => {
              const price = item.amount || 0;
              const isCheckedCard =
                checkCard.amount === price &&
                checkCard.id === item.id &&
                isCheckCard;
              return (
                <FoxGiftCouponCard
                  isActive={isCheckedCard}
                  onClick={() => {
                    setCheckCard(item);
                    setFoxTopUpStore((state) => {
                      state.amount = price;
                      state.isCheckCard = true;
                    });
                  }}
                  key={item.id}
                >
                  {item.iconWord && item.iconWord !== "" && (
                    <CommonCornerMark>{item.iconWord}</CommonCornerMark>
                  )}
                  <div className="recharge-price">
                    <div>
                      <span className="unit">{currencySymbol}</span>
                      <span className="price">{price}</span>
                    </div>
                    {isCheckedCard && <CheckIcon fill="#F3512B" />}
                  </div>
                  {(!item.detailList ||
                    !item.detailList.length ||
                    item.detailList.length <= 1) && (
                    <div className="extra-welfare">
                      <div className="tip-text">
                        {t("topUp_first_extra_welfare")}
                      </div>
                      <div className="gift-amount">
                        <CouponIcon />
                        <span>
                          {currencySymbol}
                          {presentAmountCalculate(
                            activityInfo,
                            price,
                            item.presentAmount
                          ) ?? 0}
                          &nbsp;
                          {couponTypeTranslate(item.couponType ?? 0)}
                        </span>
                      </div>
                    </div>
                  )}
                </FoxGiftCouponCard>
              );
            })}
          </FoxGiftCouponCardList>
        </div>
        {activityInfo.activityDetail.length > 4 && !isRightHidden && (
          <RightIcon
            onClick={scrollRight}
            className="scroll-button right-button"
          />
        )}
      </CardListContent>
    </FoxGiftCouponWrapper>
  );
}
